import { useCommonTranslations } from '@creativegs/pipe-toolkit/utils/translation'
import * as NextHead from 'next/head'

const Head: React.FC = () => {
  const { t: commonT } = useCommonTranslations()

  return (
    <NextHead.default>
      <title>{commonT('meta_data.title')}</title>
      <meta property="og:title" content={`${commonT('meta_data.title')}`} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="" />
      <meta property="og:url" content="https://certifiedketodiet.com" />
      <meta
        property="og:description"
        content={`${commonT('meta_data.description')}`}
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#2a9d8f" />
      <meta name="msapplication-TileColor" content="#264653" />
      <meta name="theme-color" content="#264653" />
      <meta
        name="description"
        content={`${commonT('meta_data.description')}`}
      />
      <meta name="keywords" content={`${commonT('meta_data.keywords')}`} />
    </NextHead.default>
  )
}

export default Head
